import { onAllPreloadScriptsLoaded } from "../../utils"

class CallbackButton {
    constructor(document: Document) {
        const callbackLink: HTMLOcLinkV2Element | null = document.querySelector(".fti-ci-js-callback-link")
        const callbackButton: HTMLOcButtonV1Element | null = document.querySelector(".fti-ci-js-callback-button")
        if (callbackLink != null) {
            callbackLink.addEventListener("click", () => {
                this.switchToPhoneNumber(callbackLink)
            })
        }
        if (callbackButton != null) {
            callbackButton.addEventListener("click", () => {
                this.switchToPhoneNumber(callbackButton)
            })
        }
    }

    private switchToPhoneNumber(callbackLink: HTMLOcLinkV2Element | HTMLOcButtonV1Element) {
        callbackLink.textContent = "040-36033603"
        callbackLink.setAttribute("href", "tel:+494036033603")
        const trackingPayload = callbackLink.getAttribute("data-fti-ci-callback-tracking-payload") || ""
        /*                                                                  */
        setTimeout(() => {
            callbackLink.setAttribute("data-tr-v1", trackingPayload)
        })
        callbackLink.focus()
    }
}

onAllPreloadScriptsLoaded(() => new CallbackButton(document))

export default CallbackButton
